function LoadingState({ label = 'Loading community posts' }) {
    return (
        <div className="loading-state" role="status" aria-live="polite" aria-label={label}>
            <div className="loading-brand-mark" aria-hidden="true">B</div>
            <div className="loading-copy">
                <span className="eyebrow">A moment, please</span>
                <strong>{label}</strong>
            </div>
            <div className="loading-skeleton" aria-hidden="true">
                <span className="skeleton-line skeleton-line-short" />
                <span className="skeleton-line skeleton-line-title" />
                <span className="skeleton-line" />
                <span className="skeleton-line skeleton-line-medium" />
            </div>
            <span className="visually-hidden">Please wait</span>
        </div>
    );
}

export default LoadingState;